<div class="kr-transfer-details__header" data-testid="transfer_details_header">
  <h4
    class="kr-transfer-details__header-text"
    data-testid="transfer_details_header_text">
    {{ header }}
  </h4>

  <button
    class="kr-transfer-details__header-btn-close"
    type="button"
    fuButton
    uiType="quaternary"
    size="m"
    [onlyIcon]="true"
    (click)="close()"
    data-testid="transfer_details_close_btn">
    <fu-icon
      iconName="close-square"
      data-testid="transfer_details_close_icon"></fu-icon>
  </button>
</div>

<div class="kr-transfer-details__body" data-testid="transfer_details_body">
  <h5
    class="kr-transfer-details__message"
    translate="transferDetails.message"
    data-testid="transfer_details_message"></h5>

  <div
    class="kr-transfer-details__wallets"
    data-testid="transfer_details_wallets">
    <kr-wallet-card
      data-testid="transfer_details_wallet_from"
      [wallet]="walletFrom" />

    <fu-icon
      iconName="arrow-right-filled"
      size="48"
      data-testid="transfer_details_wallets_arrow_icon">
    </fu-icon>

    @if (walletTo) {
      <kr-wallet-card
        data-testid="transfer_details_wallet_to"
        [wallet]="walletTo" />
    } @else {
      <div
        class="kr-transfer-details__external-wallet"
        data-testid="transfer_details_external_wallet">
        <fu-icon
          iconName="card"
          size="32"
          data-testid="transfer_details_external_wallet_icon">
        </fu-icon>
      </div>
    }
  </div>

  <div
    class="kr-transfer-details__content"
    data-testid="transfer_details_content">
    <section
      class="kr-transfer-details__content-row"
      data-testid="transfer_details_row_from_amount">
      <div class="kr-details" data-testid="transfer_details_from_block">
        <label
          class="kr-details__label"
          translate="transferDetails.label.from"
          data-testid="transfer_details_from_label">
        </label>

        <span
          class="kr-details__value"
          data-testid="transfer_details_from_value">
          {{ transfer.walletId }}
        </span>
      </div>

      <div class="kr-details" data-testid="transfer_details_amount_block">
        <label
          class="kr-details__label"
          translate="transferDetails.label.amount"
          data-testid="transfer_details_amount_label">
        </label>

        <span
          class="kr-details__value"
          [title]="
            transfer.totalAmount | balanceFormat: this.walletFrom.coin.symbol
          "
          data-testid="transfer_details_amount_value">
          {{
            transfer.totalAmount | balanceFormat: this.walletFrom.coin.symbol
          }}
        </span>
      </div>
    </section>

    <section
      class="kr-transfer-details__content-row"
      data-testid="transfer_details_row_to_receives">
      <div class="kr-details" data-testid="transfer_details_to_block">
        <label
          class="kr-details__label"
          translate="transferDetails.label.to"
          data-testid="transfer_details_to_label">
        </label>

        <span class="kr-details__value" data-testid="transfer_details_to_value">
          {{ transfer.toWalletId || transfer.address }}
        </span>
      </div>

      <div class="kr-details" data-testid="transfer_details_receives_block">
        <label
          class="kr-details__label"
          translate="transferDetails.label.receives"
          data-testid="transfer_details_receives_label">
        </label>

        <span
          class="kr-details__value"
          [title]="transfer.amount | balanceFormat: this.walletFrom.coin.symbol"
          data-testid="transfer_details_receives_value">
          {{ transfer.amount | balanceFormat: this.walletFrom.coin.symbol }}
        </span>
      </div>
    </section>

    <section
      class="kr-transfer-details__content-row"
      data-testid="transfer_details_row_fee_risk">
      <div class="kr-details" data-testid="transfer_details_fee_block">
        <label
          class="kr-details__label"
          translate="transferDetails.label.fee"
          data-testid="transfer_details_fee_label">
        </label>

        <span
          class="kr-details__value"
          [title]="
            transfer.feeTotal | balanceFormat: this.walletFrom.coin.symbol
          "
          data-testid="transfer_details_fee_value">
          {{ transfer.feeTotal | balanceFormat: this.walletFrom.coin.symbol }}
        </span>
      </div>
      <!--      @if (transfer?.riskScore) {-->
      <!--        <div class="kr-details" data-testid="transfer_details_risk_block">-->
      <!--          <label-->
      <!--            class="kr-details__label"-->
      <!--            translate="transferDetails.label.riskAScore"-->
      <!--            data-testid="transfer_details_risk_label">-->
      <!--          </label>-->

      <!--          <span-->
      <!--            class="kr-details__value"-->
      <!--            [ngClass]="{ danger: !transfer.riskScorePassed }"-->
      <!--            data-testid="transfer_details_risk_value">-->
      <!--            @if (transfer.riskScoreError) {-->
      <!--              <kr-copy-tooltip-->
      <!--                data-testid="transfer_details_risk_error_tooltip"-->
      <!--                [text]="transfer.riskScoreError" />-->
      <!--            } @else {-->
      <!--              <kr-risk-score-value-->
      <!--                data-testid="transfer_details_risk_score_value"-->
      <!--                [score]="transfer?.riskScore"-->
      <!--                [level]="transfer.riskLevel" />-->
      <!--            }-->
      <!--          </span>-->
      <!--        </div>-->
      <!--      }-->
    </section>
    <div class="kr-details" data-testid="transfer_details_details_block">
      <label
        class="kr-details__label"
        translate="transferDetails.label.details"
        data-testid="transfer_details_details_label">
      </label>

      <span
        class="kr-details__value"
        data-testid="transfer_details_details_value">
        {{ transfer.comment }}
      </span>
    </div>
    <kr-warning-save-balance
      data-testid="transfer_details_warning_save_balance"
      [warningKey]="'errors.notEnoughFundsToPay'"
      [amount]="transfer.ourEstimatedFee"
      [balance]="walletFrom.networkBalance" />
  </div>

  <div class="kr-actions" data-testid="transfer_details_actions">
    <button
      type="button"
      fuButton
      size="m"
      uiType="primary"
      (click)="close()"
      translate="transferDetails.btn.back"
      data-testid="transfer_details_back_btn"></button>

    <!--      [disabled]="!transfer.riskScorePassed && transfer.riskScore"-->
    <button
      type="button"
      fuButton
      size="m"
      uiType="primary"
      (click)="execute()"
      translate="transferDetails.btn.execute"
      data-testid="transfer_details_execute_btn"></button>
  </div>
</div>

<ng-template #successTpl data-testid="transfer_details_success_tpl">
  <fu-icon
    iconName="success"
    size="64"
    data-testid="transfer_details_success_icon">
  </fu-icon>

  <h5
    class="kr-transfer-details__message"
    translate="transferDetails.success.message"
    data-testid="transfer_details_success_message"></h5>

  <div
    class="kr-details kr-details_center"
    data-testid="transfer_details_success_txid_block">
    <label
      class="kr-details__label"
      translate="transferDetails.success.label.transactionId"
      data-testid="transfer_details_success_txid_label">
    </label>

    <span
      class="kr-details__value kr-details__value_hover"
      (click)="clipboard.copy('' + response().transactionId)"
      data-testid="transfer_details_success_txid_value">
      {{ response().transactionId }}
      <fu-icon
        iconName="copy"
        size="16"
        data-testid="transfer_details_success_txid_copy_icon">
      </fu-icon>
    </span>
  </div>

  @if (response().tx) {
    <div
      class="kr-details kr-details_center"
      data-testid="transfer_details_success_txhash_block">
      <label
        class="kr-details__label"
        translate="transferDetails.success.label.transactionHash"
        data-testid="transfer_details_success_txhash_label">
      </label>

      <span
        class="kr-details__value kr-details__value_hover"
        (click)="clipboard.copy(response().tx)"
        data-testid="transfer_details_success_txhash_value">
        {{ response().tx }}
        <fu-icon
          iconName="copy"
          size="16"
          data-testid="transfer_details_success_txhash_copy_icon">
        </fu-icon>
      </span>
    </div>
  }
</ng-template>

<ng-template #failedTpl data-testid="transfer_details_failed_tpl">
  <fu-icon
    iconName="failed"
    size="64"
    data-testid="transfer_details_failed_icon">
  </fu-icon>

  <h5
    class="kr-transfer-details__message"
    translate="transferDetails.failed.message"
    data-testid="transfer_details_failed_message"></h5>

  <div
    class="kr-details kr-details_center"
    data-testid="transfer_details_failed_error_block">
    <label
      class="kr-details__label"
      translate="transferDetails.failed.label.error"
      data-testid="transfer_details_failed_error_label">
    </label>

    <span
      class="kr-details__value kr-details_danger"
      data-testid="transfer_details_failed_error_value">
      {{ errMessage }}
    </span>
  </div>
</ng-template>
